import MainLayout from '@/components/layout/MainLayout.vue';
import { required, email, sameAs, minLength, maxLength, numeric, helpers } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import $ from "jquery";
import axios from "axios";

const phoneFormat = helpers.regex('phoneFormat', /^(\+?95|0)?(9\d{7,9})$/);

export default {
  name: "signupSchool",

  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      signupForm: {
        profile: '',
        name: '',
        phone_number_1: '',
        email_1: '',
        phno_valid: '',
        password: '',
        confirm_password: '',
      },
      profile: '',
      errorArr: [],
      submitted: false,
      disabled: false,
      isLoading: false,
    }
  },

  validations: {
    signupForm: {
      name: {
        required,
        maxLength: maxLength(100)
      },
      phno_valid: {
        maxLength: maxLength(20),
        numeric
      },
      phone_number_1: {
        required,
        maxLength: maxLength(20),
        phoneFormat
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(12)
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs("password")
      },
      email_1: {
        email
      }
    }
  },

  methods: {
    onProfileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return null;
      this.signupForm.profile = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.profile = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },

    submit() {
      this.submitted = true;
      if (this.$v.signupForm.$invalid) {
        return;
      }
      this.signUp();
    },

    signUp() {
      this.isLoading = true;
      this.disabled = true;
      this.signupForm.profile = this.profile;
      axios.post("/validate/school", this.signupForm, {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push({
              name: "teacherPayment",
              query: {
                type: 'school',
                signupForm: JSON.stringify(this.signupForm)
              }
            });
          }
        }).catch((error) => {
          this.isLoading = false;
          this.disabled = false;
          this.errorArr = error.response.data.errors;
          this.loading = false;
        });
    }
  },

  mounted() {
    $("#phone_number_1").on("keypress keyup blur", function (event) {
      $(this).val($(this).val().replace(/[^\d].+/, ""));
      if ((event.which < 48 || event.which > 57)) {
        event.preventDefault();
      }
    });
  },
};
